import { ConfirmDialogTranslation } from '@/assets/locales/components/confirmDialog/confirmDialog.translation.en.ts';

export const confirmDialogTranslation: ConfirmDialogTranslation = {
  buttons: {
    cancel: 'Anuluj',
    close: 'Zamknij',
    confirm: 'Potwierdź',
  },
  title: 'Potwierdzenie',
};
